<template>
    <el-drawer class="drawer" ref="drawer" :title="title" :visible.sync="drawer" :direction="direction" :destroy-on-close="true"  @opened="getlist" :before-close="handleClose" :size="size">
        <!-- 添加 -->
        <template v-if="source == 'add' || source == 'addTabs'">
            <!-- table 列表 -->
            <el-table
                v-loading="addLoading"
                :data="tableData.filter(data => !addSearch || data.name.toLowerCase().includes(addSearch.toLowerCase()))"
                style="width: 100%" :height="tableHeight"
            >
                <el-table-column property="name" label="报表名称" show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-input v-model="addSearch" size="mini" clearable placeholder="报表名称 模糊搜索" />
                    </template>
                    <template slot-scope="scope">
                        <svg-icon v-if="scope.row.modelType==1" icon-class="sjfx" style="width:20px;height:18px;" class="icon" />
                        <svg-icon v-if="scope.row.modelType==2" icon-class="gssql" style="width:20px;height:20px;" class="icon" />
                        {{scope.row.name}}
                    </template>
                </el-table-column>

                <el-table-column property="updateTime" label="修改时间" width="120" show-overflow-tooltip></el-table-column>

                <el-table-column property="useed" label="使用状态" width="100">
                <template slot-scope="scope">
                    <span v-if="scope.row.useed" style="color:#1890ff">
                    已使用
                    </span>
                    <span v-if="scope.row.useed==false" style="color:#EE6363">
                    未使用
                    </span>
                </template>
                </el-table-column>

                <el-table-column property="modelType" label="报表类型" width="100" :filters="[{ text: '事件分析', value: 1 }, { text: '高级sql', value: 2 }]" :filter-method="filterTag" :filter-multiple="false"
                filter-placement="bottom-end">
                <template slot-scope="scope">
                    <span v-if="scope.row.modelType==1">
                    事件分析
                    </span>
                    <span v-if="scope.row.modelType==2">
                    高级sql
                    </span>
                </template>
                </el-table-column>

                <el-table-column label="操作" width="100">
                    <template slot-scope="scope">
                        <el-button size="mini" style="color:#EE6363" v-if="scope.row.selected" @click="scope.row.selected=false">移除</el-button>
                        <el-button size="mini" style="color:#1890ff" v-else @click="scope.row.selected=true">添加</el-button>
                    </template>
                </el-table-column>

            </el-table>
        </template>

        <!-- 共享 -->
        <template v-if="source == 'share'">
            <el-select class="select-box" v-model="shareValue" placeholder="请选择共享人" size="small">
                <el-option v-for="(item, index) in shareOption" :key="index" :label="item.label" :value="item.value"></el-option>
            </el-select>

            <div class="content-box" v-if="shareValue == 1 || shareValue == 2">
                <svg-icon class="icon" icon-class="yonghuzu"  />
                <div class="text" v-if="shareValue == 1">仅自己有权限查看看板</div>
                <div class="text" v-if="shareValue == 2">项目组任何成员都有权限查看看板</div>
            </div>
     
            <template v-else>
                <el-table 
                    v-loading="shareLoading"
                    :data="tableShareData.filter(data => !shareSearch || data.realname.toLowerCase().includes(shareSearch.toLowerCase()))"
                    style="width: 100%" :height="tableShareHeight" size="mini"
                >
                    <el-table-column property="realname" label="名称" show-overflow-tooltip>
                        <template slot="header" slot-scope="scope">
                            <el-input v-model="shareSearch" size="mini" clearable placeholder="名称 模糊搜索" />
                        </template>
                        <template slot-scope="scope">
                            {{scope.row.realname}}
                        </template>
                    </el-table-column>

                    <el-table-column label="操作" width="100">
                        <template slot-scope="scope">
                            <el-button size="mini" style="color:#EE6363" v-if="scope.row.locked == '1'" @click="scope.row.locked='0'">移除</el-button>
                            <el-button size="mini" style="color:#1890ff" v-else @click="scope.row.locked='1'">添加</el-button>
                        </template>
                    </el-table-column>

                </el-table>
            </template>
        </template>

        <div class="dialog-butn-box" style="margin: 20px">
            <el-button size="mini" type="primary" :loading='butnLoading' @click="handleSave">应用</el-button>
            <el-button size="mini" @click="handleClose">关闭</el-button>
        </div>
    </el-drawer>
</template>

<script>
import { ajax_zhibiaoliebiao, ajax_shareduserlist, ajax_createView, ajax_sharedalluser, ajax_shareduser, ajax_viewlist} from '@Bdc~/api/ajax_model'
export default {
    props: {
        // 标题
        title: {
            type:String,
            default: ''
        },
        // 弹框大小
        size: {
            type:String,
            default: '700px'
        },
        // 来源
        source: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            drawer: false,
            direction: 'rtl',
            butnLoading: false,
            // 添加
            addLoading:true,
            tableData:[],
            tableHeight: `calc(100vh - 200px)`,
            addSearch:'', // 搜索

            // 共享
            shareValue: '1',
            shareOption: [
                {
                    value: "1",
                    label: "仅自己可见"
                },
                {
                    value: "2",
                    label: "全部成员可见"
                },
                {
                    value: "3",
                    label: "指定成员可见"
                }
            ],
            tableShareHeight: `calc(100vh - 260px)`,
            shareLoading:true,
            tableShareData:[],
            shareSearch:'', // 搜索

            modelId:'' // 模块id
        }
    },
    methods: {
        // 初始化
        init(id) {
            this.modelId = id
            // console.log(this.modelId)
            this.drawer = true
            this.butnLoading = false // 确定loding

            if(this.source == 'add') {
                this.addLoading = true
                this.tableData = []
                this.addSearch = ''
            } else {
                this.shareValue = '1'
                this.shareLoading = true
                this.tableShareData = []
                this.shareSearch = '' // 搜索
            }
        },

        getlist() {
            let id = this.$store.getters.currentRoute.meta.id
            if(this.source == 'add') { 
                ajax_zhibiaoliebiao(id).then(response => {
                    this.addLoading = false
                    if(response.code == 1) {    
                        this.tableData = response.data
                    }
                })
            } else if(this.source == 'addTabs') {
                const vid = this.modelId
                ajax_viewlist(vid).then(response => {
                    this.addLoading = false
                    if(response.code == 1) {    
                        this.tableData = response.data
                    }
                })
            } else if(this.source == 'share') {
                ajax_shareduserlist(id).then(response => {
                    this.shareLoading = false
                    if(response.code == 1) {    
                        this.tableShareData = response.data
                    }
                })
            }
        },

        // 报表类型转换
        filterTag(value, row) {
            return row.modelType === value;
        },

        // 关闭
        handleClose(done) {
            if(typeof done == 'function') {
                done();
            } else {
                this.$refs['drawer'].closeDrawer()
            }
        },

        // 保存
        handleSave() {
            this.butnLoading = true // 确定loding
            if(this.source == 'add' || this.source == 'addTabs') {
                let views = []
                this.tableData.forEach(m => {
                    if(m.selected) {
                        views.push({
                           kpiId: m.id,
                           code: m.code  
                        })
                    }
                })

                // 提交数据
                let data = {
                    menuId: this.$store.getters.currentRoute.meta.id,
                    menuTarget: this.$store.getters.currentRoute.meta.target,
                    views: views
                } 

                if(this.source == 'addTabs') {
                   data.viewId = this.modelId
                }
                
                // console.log('应用：', data)
                ajax_createView(data).then(response => {
                    this.butnLoading = false // 确定loding
                    if(response.code == 1) {
                        this.drawer = false
                        this.$emit('repeatList')
                    }
                })
            } else if(this.source == 'share') {
                if(this.shareValue == 2) { // 分享全员
                    const id = this.$store.getters.currentRoute.meta.id
                    ajax_sharedalluser(id).then(response => {
                        this.butnLoading = false // 确定loding
                        if(response.code == 1) {
                            this.drawer = false
                            this.$emit('repeatList')
                        }
                    })
                } else { // 分享自己 或 其他人
                    let users = []
                    if(this.shareValue == 3) {
                        this.tableShareData.forEach(m => {
                            if(m.locked == '1') {
                                users.push(m.id)
                            }
                        })
                    }

                    const data = {
                        gameKey: this.$store.getters.appkey,
                        userId: this.$store.getters.userId,
                        menuId: this.$store.getters.currentRoute.meta.id,
                        users: users //如果设置仅自己可见该参数传空集合或不传都可以
                    }
                    ajax_shareduser(data).then(response => {
                        this.butnLoading = false // 确定loding
                        if(response.code == 1) {
                            this.drawer = false
                            this.$emit('repeatList')
                        }
                    })
                }
            }
        },
    }
}
</script>

<style lang="scss" scoped>
    .drawer{
        ::v-deep .el-drawer__header{
            margin-bottom: 10px;
        }
    }

    .select-box{
        margin:10px 20px;
    }

    .content-box{
        height: calc(100vh - 260px);
        display: flex;
        flex-flow: column nowrap;
        justify-content: center;
        align-items: center;

        .icon{
            width:100px;
            height:100px;
            color:#1890ff
        }
        .text{
            color:#1890ff
        }
    }

    ::v-deep :focus {
        outline: 0;
    }
</style>